export default "__VITE_PUBLIC_ASSET__f1aedd12__"